// Import necessary libs
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import oidcConfig from "./components/Auth/oidcConfig";
import env from "./config/env";

// Authentication configuration is set up with values from environment variables

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
}

window.addEventListener("error", (event: ErrorEvent) => {
  if (
    event.message &&
    event.message.includes("ResizeObserver loop completed with undelivered notifications")
  ) {
    event.preventDefault();
    // Optionally, return true to signal that the error is handled.
    return true;
  }
});
